import Input from "../../Input"

const ClockChannel = ({ index, values, serverData }) => {
    return (
        <div className="mx-14 h-full">
            <h6 className="flex justify-center">چنل ساعت {index + 1}</h6>
            <div className="font-sans">
                <Input
                    type="number"
                    name={`clockChannels-${index}-id`}
                    label="ایدی چنل *"
                    id="bot-name"
                    placeholder="ChannelID"
                    autoComplete="off"
                    dir="ltr"
                    options={serverData?.channelList}
                    defaultValue={values?.id}
                />
            </div>
            <div className="mt-2">
                <Input
                    type="text"
                    name={`clockChannels-${index}-format`}
                    label="فرمت *"
                    placeholder="format"
                    autoComplete="off"
                    dir="ltr"
                    defaultValue={values?.format}
                />
            </div>
            <div className="mt-5 p-2 text-gray-400 border-gray-700 border rounded-md font-sans">
                <span>متغیرها:</span>
                <div dir="ltr" className="">
                    <div>%clock: ساعت به انگلیسی</div>
                    <div>%saat: ساعت به فارسی</div>
                </div>
            </div>
        </div>
    )
}

export default ClockChannel
